import React from "react";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import SelectAddressModel from "../../components/selectAddressModel/SelectAddressModel";
import "./cart.css";

import {
  openNewLogin,
  openSelectAddressModel,
  setReadFullPolicyModelTrue,
} from "../../store/slices/modalSlice";
import AddAnotherAddressModel from "../../components/addAnotherAddress/AddAnotherAddress";
import AddDetailModel from "../../components/AddDetail/AddDetailModel";

const LoginModel = React.lazy(() => import("../../components/LoginModel/LoginModel"));
import { Link, useNavigate } from "react-router-dom";
import AddressFromMap from "../../components/selectAddressFromMapModel/AddressFromMap";
import Coupons from "../../components/coupons/Coupons";
import cartImg from "../../assets/cart.svg";
import { AddressRecord, UserDataType } from "../../types/cart";
import {
  removeItemFromLocalStorage,
  removeItemFromSessionStorage,
} from "../../lib/api";
import { useCart } from "../../hooks/useCart";
import CartPackage from "../../components/cartPackage/CartPackage";
import HandleReadFullPolicyModel from "../../components/handleModel/HandleReadFullPolicyModel";
import HandlePackageAndServiceModel from "../../components/handleModel/HandlePackageAndServiceModel";

const VerifyOtp = React.lazy(() => import("../../components/otp/VerifyOtp"));
import Tips from "../../components/Tips/Tips";
import PaymentDetails from "../../components/PaymentDetails/PaymentDetails";

const Cart = () => {
  const { getData } = useCart();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [tooken, settoken] = useState<string | null>(null);
  const [address, setAddress] = useState<AddressRecord | null>();
  const [number, setNumber] = useState({ countryCode: "", phoneNumber: "" });

  const openSelectAddress = () => {
    dispatch(openSelectAddressModel());
  };

  const isMobile = useSelector(
    (store: { ID: { isMobile: boolean } }) => store.ID.isMobile
  );
  const discount = useSelector(
    (store: { ID: { discount: number } }) => store.ID.discount
  );
  const tipValue = useSelector(
    (store: { ID: { tipValue: number } }) => store.ID.tipValue
  );

  const totalAmount = useSelector(
    (store: { ID: { cartValuePrice: number } }) => store.ID.cartValuePrice
  );




  const showSelectAddress = useSelector(
    (state: { modal: { selectAddressModel: boolean } }) =>
      state.modal.selectAddressModel
  );

  const showAddAddress = useSelector(
    (state: { modal: { addAnotherAddress: boolean } }) =>
      state.modal.addAnotherAddress
  );

  const showDetailModel = useSelector(
    (state: { modal: { addDetailModel: boolean } }) =>
      state.modal.addDetailModel
  );

  const showLoginModel = useSelector(
    (state: { modal: { login: boolean } }) => state.modal.login
  );

  const showVerifyOtp = useSelector(
    (state: { modal: { verifyOtp: boolean } }) => state.modal.verifyOtp
  );

  const login = useSelector(
    (state: { signin: { userData: UserDataType } }) => state.signin.userData
  );

  const showAddAddressFromMap = useSelector(
    (state: { modal: { addressFromMap: boolean } }) =>
      state.modal.addressFromMap
  );

  const handleData = () => {
    navigate("/uploadocument");
  };

  const address1 = sessionStorage.getItem("address");

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    if (address1) {
      const addre = JSON.parse(address1);
      setAddress(addre);
    } else {
      setAddress(null);
    }
  }, [address1]);

  useEffect(() => {
    const token = sessionStorage.getItem("tk");
    if (token) {
      settoken(token);
    } else {
      settoken(null);
      removeItemFromLocalStorage("Login_info");
      removeItemFromLocalStorage("rt");
      removeItemFromLocalStorage("Login_info_status");
      removeItemFromLocalStorage("cartDataLocal");
      removeItemFromLocalStorage("count");
      removeItemFromLocalStorage("userName");
      removeItemFromLocalStorage("orderNumber");
      removeItemFromLocalStorage("carts");
      removeItemFromLocalStorage("phoneNumber");

      removeItemFromSessionStorage("tk");
      removeItemFromSessionStorage("userName");
      removeItemFromSessionStorage("billing");
      removeItemFromSessionStorage("address");
    }
    const num = localStorage.getItem("phoneNumber");
    if (num) {
      const nm = JSON.parse(num);
      setNumber(nm[0]);
    }
  }, [login]);
  const handleLogin = () => {
    dispatch(openNewLogin());
  };

  useEffect(() => {
    const applyFooterPosition = () => {
      const footer = document.getElementById("fixed-footer");
      const column = document.getElementById("cart-column");

      if (!footer || !column) return;

      const rect = column.getBoundingClientRect();
      footer.style.left = `${rect.left}px`;
      footer.style.width = `${rect.width}px`;
      footer.style.visibility = "visible";
      footer.style.opacity = "1";
    };
    const onLoad = () => {
      requestAnimationFrame(() => {
        requestAnimationFrame(applyFooterPosition); // double RAF ensures layout settle
      });
    };

    if (document.readyState === "complete") {
      onLoad(); // Already loaded
    } else {
      window.addEventListener("load", onLoad);
    }

    const resizeObserver = new ResizeObserver(() => applyFooterPosition());
    const column = document.getElementById("cart-column");
    if (column) resizeObserver.observe(column);

    window.addEventListener("resize", applyFooterPosition);
    window.addEventListener("scroll", applyFooterPosition, true);

    return () => {
      resizeObserver.disconnect();
      window.removeEventListener("resize", applyFooterPosition);
      window.removeEventListener("scroll", applyFooterPosition, true);
      window.removeEventListener("load", onLoad);
    };
  }, []);

  const openReadFullPolicy = () => {
    dispatch(setReadFullPolicyModelTrue());
  };

  const handleScroll = () => {
    const section = document.getElementById("target-section");
    if (section) {
      section.scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest",
      });
    }
  };

  return (
    <>
      {totalAmount && totalAmount > 0 ? (
        <section className="cartPage-wrap py-0  my-4 my-md-5">
          <div className="container cart-container mt-5">
            <div className="row flex-column-reverse flex-md-row justify-content-center">
              <div className="col-md-7  mb-3 mb-md-0">
                <div className="position-sticky" style={{ top: "72px" }}>
                  {discount > 1 && (
                    <div className="Saved-section p-0  rounded text-center bg-white mb-3 d-flex align-items-center gap-2 justify-content-md-start justify-content-between ">
                      <div>
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M8.7792 0.0445013C7.74169 0.121096 7.38657 0.288212 6.24461 1.2352C4.27403 2.87155 0.632299 6.76395 0.214509 7.68309C-0.154538 8.49082 -0.0500908 9.21499 0.548741 10.0158C1.60018 11.4223 4.34367 14.2772 5.41599 15.078C6.18194 15.6559 6.46047 15.7812 6.99663 15.7812C7.34479 15.7812 7.49798 15.7395 7.84614 15.5515C8.34748 15.2869 9.59389 14.319 9.56604 14.2145C9.55907 14.1728 9.29447 14.0335 8.98113 13.9012C8.67475 13.7689 8.32659 13.5879 8.20822 13.4973C7.67902 13.1074 7.51887 12.1952 7.86703 11.5964C8.1177 11.1716 8.25 11.0672 8.84187 10.8304C10.0117 10.35 10.3947 9.96701 10.8542 8.80416C11.1606 8.01732 11.6132 7.68309 12.3513 7.67613C12.6855 7.67613 12.8387 7.71791 13.0824 7.85717C13.5072 8.10784 13.6047 8.23318 13.8623 8.85987C14.2383 9.75811 14.1826 9.73026 14.6213 9.18713C15.5961 7.97554 15.5892 8.03125 15.631 4.70982C15.6658 2.04989 15.6379 1.54854 15.4081 1.06112C15.241 0.712965 14.8929 0.392659 14.4681 0.190727L14.0851 0.0166483L11.8221 0.00272274C10.5757 -0.00424099 9.20395 0.00968552 8.7792 0.0445013ZM12.9292 2.27968C13.6116 2.66265 13.737 3.57483 13.1869 4.12492C12.4418 4.86997 11.1954 4.37559 11.1815 3.33111C11.1815 2.84369 11.4113 2.46072 11.8569 2.21701C12.0867 2.08471 12.6438 2.11952 12.9292 2.27968Z"
                            fill="#29844D"
                          />
                          <path
                            d="M12.0159 8.74659C11.9532 8.78837 11.8348 8.9903 11.7583 9.1992C11.5145 9.85373 11.2848 10.2437 10.9157 10.6475C10.484 11.121 10.0871 11.3856 9.39774 11.6711C8.80587 11.9148 8.6875 12.0193 8.6875 12.3187C8.6875 12.646 8.79891 12.7643 9.30722 12.9593C10.5049 13.4119 11.2291 14.1361 11.7234 15.3686C11.9254 15.8699 12.0368 15.9883 12.3292 15.9883C12.6426 15.9883 12.7749 15.8769 12.9281 15.466C13.1718 14.8115 13.4016 14.4216 13.7706 14.0177C14.2023 13.5442 14.5992 13.2796 15.2886 12.9941C15.8804 12.7504 15.9988 12.646 15.9988 12.3465C15.9988 12.0193 15.8874 11.9009 15.3791 11.7059C14.1814 11.2533 13.4573 10.5292 12.9629 9.29668C12.8654 9.05297 12.7331 8.80926 12.6704 8.76052C12.5381 8.66303 12.183 8.65607 12.0159 8.74659Z"
                            fill="#29844D"
                          />
                        </svg>
                      </div>

                      <span className="font-13 ff-semibold text-dark">
                        You're saving total AED {discount.toFixed(2)} on this
                        order!
                      </span>
                    </div>
                  )}
                  {!isMobile && (
                    <>
                      {tooken !== null ? (
                        <>
                          <div className="address-card ">
                            <div className="d-flex align-items-center gap-3 border-bottom p-3">
                              <div className="cart-map-ico ">
                                <img
                                  src="https://goodhand.b-cdn.net/Assets/cart/cart-flow/booking-details.svg"
                                  className="img-fluid"
                                  alt=""
                                />
                              </div>

                              <div className="flex-grow-1">
                                <p className="mb-0 font-14 ff-semibold text-black">
                                  Order details will be forwarded to
                                </p>
                                <p className="mb-0 font-14 ">
                                  {number.countryCode + number.phoneNumber}
                                </p>
                              </div>
                            </div>

                            <div
                              className={`d-flex align-items-center gap-3 p-3 border-bottom ${
                                address === null ? "flex-wrap" : ""
                              }`}
                            >
                              <div
                                className={`cart-map-ico ${
                                  address?.streetName ?? "ahead"
                                } col-3`}
                              >
                                <img
                                  src="https://goodhand.b-cdn.net/Assets/cart/cart-flow/adress.svg"
                                  className="img-fluid ahead"
                                  alt=""
                                />
                              </div>

                              <div className="flex-grow-1">
                                <div>
                                  <p className="mb-0 font-14 ff-semibold text-black">
                                    Adress
                                  </p>
                                  <p className="font-12 mb-0">
                                    {address?.streetName
                                      ? " "
                                      : "Please select the address to pick document"}
                                  </p>
                                  {address && (
                                    <p className="font-12">
                                      {/* Home - axis6, yty, ديرة - دبي - United Arab */}
                                      {address?.streetName}
                                    </p>
                                  )}
                                </div>
                              </div>
                              {address !== null && (
                                <div className="d-flex justify-content-start align-items-center">
                                  <a className="text-decoration-none">
                                    <button
                                      type="button"
                                      className="btn-add position-relative my-2 px-3"
                                      onClick={openSelectAddress}
                                      style={{
                                        width: "fit-content",
                                      }}
                                    >
                                      Edit
                                    </button>
                                  </a>
                                </div>
                              )}
                              {address === null && (
                                <div className="text-center d-flex col-12">
                                  <button
                                    onClick={openSelectAddress}
                                    className="btn btn-primary  w-100 font-14 ff-semibold py-3  bt--cart"
                                  >
                                    Add Address
                                  </button>
                                </div>
                              )}
                            </div>

                            <div className="d-flex align-items-center gap-3 p-3 flex-wrap">
                              <div className="cart-map-ico ahead">
                                <img
                                  src="https://goodhand.b-cdn.net/Assets/cart/cart-flow/documents.svg"
                                  className="img-fluid"
                                  alt=""
                                />
                              </div>

                              <div className="flex-grow-1">
                                <p
                                  className={`mb-0 font-14 ff-semibold ${
                                    !address ? "disabled" : "text-black"
                                  }`}
                                >
                                  Documents
                                </p>
                                <p className="font-12 mb-0">
                                  Please Upload applicant documents
                                </p>
                              </div>
                              {address !== null && (
                                <>
                                  <div className="text-center d-flex col-12 flex-grow-1">
                                    <button
                                      className="btn btn-primary  ff-semibold w-100 font-14 py-3 mx-3 bt--cart"
                                      onClick={handleData}
                                    >
                                      Upload Documents
                                    </button>
                                  </div>
                                </>
                              )}
                            </div>
                          </div>
                          <div className="policy-container py-3 ">
                            <div className="policy-item">
                              <h4 className="policy-title">
                                Cancellation policy
                              </h4>
                            </div>

                            <div className="policy-item">
                              <p className="policy-text">
                                Free cancellations if done more than 4 hours
                                before the service or if a professional isn’t
                                assigned. A fee will be charged otherwise.
                              </p>
                            </div>

                            <div className="policy-item">
                              <button
                                className="read-full-policy-button p-0"
                                onClick={openReadFullPolicy}
                              >
                                <p className="read-full-policy-text">
                                  Read full policy
                                </p>
                              </button>
                            </div>
                          </div>
                        </>
                      ) : (
                        <div className="cart-content p-4">
                          <h2 className="font-14 ff-semibold"> Account </h2>
                          <p className="font-12 text-black">
                            To book the service, please login or signup
                          </p>
                          <button
                            className="btn btn-primary  w-100 font-14 ff-semibold py-3 me-3 bt--cart"
                            onClick={handleLogin}
                          >
                            Login
                          </button>
                        </div>
                      )}
                    </>
                  )}
                </div>
              </div>

              {/* <CartRightSide /> */}
              <div className="col-md-5 position-relative" id="cart-column">
                <div
                  className="cart-column-content"
                  style={{ paddingBottom: "90px" }}
                >
                  <div
                    className={`cart-summary-wrapper ${
                      isMobile ? "py-3" : "pb-2"
                    }`}
                  >
                    <CartPackage hide={false} />
                    <div id="target-section"> </div>
                    <Coupons />

                    {/* {showDetailModel && <AddDetailModel />}
                    {showLoginModel && <LoginModel />}
                    {showAddAddressFromMap && <AddressFromMap />} */}

                    <PaymentDetails />
                    <Tips />
                  </div>
                  {isMobile && (
                    <div className="policy-container py-3 ">
                      <div className="policy-item">
                        <h4 className="policy-title">Cancellation policy</h4>
                      </div>

                      <div className="policy-item">
                        <p className="policy-text">
                          Free cancellations if done more than 4 hours before
                          the service or if a professional isn’t assigned. A fee
                          will be charged otherwise.
                        </p>
                      </div>

                      <div className="policy-item">
                        <button
                          className="read-full-policy-button p-0"
                          onClick={openReadFullPolicy}
                        >
                          <p className="read-full-policy-text">
                            Read full policy
                          </p>
                        </button>
                      </div>
                    </div>
                  )}
                </div>
                <div id="fixed-footer" className="cart-column-footer-fixed">
                  {!isMobile && (
                    <div className="price-fix-inner">
                      <div className="d-flex justify-content-between align-items-center p-3 ">
                        <p className="ff-medium font-16 text-black mb-0">
                          Amount to pay
                        </p>
                        <h4 className="ff-semibold font-18 text-dark mb-0">
                          {Number(tipValue) >= 5 ? (
                            <b>
                              <span className="ff-currency ff-semibold font-17">
                                
                              </span>
                              {(totalAmount + (Number(tipValue) || 0)).toFixed(
                                2
                              )}
                            </b>
                          ) : (
                            <b>
                              <span className="ff-currency ff-semibold font-17">
                                
                              </span>{" "}
                              {totalAmount.toFixed(2)}
                            </b>
                          )}
                        </h4>
                      </div>

                      <div className="d-flex justify-content-end align-items-center p-3 pt-0 w-100">
                        <p
                          className="ff-medium font-13 text-black mb-0 text-decoration-underline cursor-pointer"
                          onClick={handleScroll}
                        >
                          View Breakup
                        </p>
                      </div>
                    </div>
                  )}
                  {isMobile && (
                    <>
                      {tooken !== null ? (
                        <>
                          <div className="address-card ">
                            <div
                              className={`d-flex align-items-center gap-3 p-3 border-bottom border-top ${
                                address === null ? "flex-wrap" : ""
                              }`}
                            >
                              <div
                                className={` ${
                                  address?.streetName ?? "ahead"
                                } `}
                              >
                                <svg
                                  width="15"
                                  height="15"
                                  viewBox="0 0 15 15"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M2.44444 7.5H1L7.5 1L14 7.5H12.5556"
                                    stroke="black"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                  <path
                                    d="M2.44444 7.5V12.5556C2.44444 12.9386 2.59663 13.306 2.86751 13.5769C3.1384 13.8478 3.5058 14 3.88889 14H11.1111C11.4942 14 11.8616 13.8478 12.1325 13.5769C12.4034 13.306 12.5556 12.9386 12.5556 12.5556V7.5"
                                    stroke="black"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                  <path
                                    d="M5.33333 14V9.66667C5.33333 9.28358 5.48552 8.91618 5.7564 8.6453C6.02729 8.37441 6.39469 8.22223 6.77778 8.22223H8.22222C8.60531 8.22223 8.97271 8.37441 9.2436 8.6453C9.51449 8.91618 9.66667 9.28358 9.66667 9.66667V14"
                                    stroke="black"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                </svg>
                              </div>

                              <div className="flex-grow-1">
                                <div>
                                  <p className="font-12 mb-0">
                                    {address?.streetName
                                      ? " "
                                      : "Please select the address to pick document Please select the address to pick document"}
                                  </p>
                                  {address && (
                                    <p className="font-12 mb-0">
                                      {/* Home - axis6, yty, ديرة - دبي - United Arab */}
                                      {address?.streetName}
                                    </p>
                                  )}
                                </div>
                              </div>
                              {address !== null && (
                                <div className="d-flex justify-content-start align-items-center">
                                  <a className="text-decoration-none">
                                    <div
                                      className="position-relative my-2 px-3"
                                      onClick={openSelectAddress}
                                      style={{
                                        width: "fit-content",
                                      }}
                                    >
                                      <svg
                                        width="13"
                                        height="13"
                                        viewBox="0 0 13 13"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          d="M1 12H3.87048L11.4055 4.46498C11.594 4.2765 11.7435 4.05274 11.8455 3.80648C11.9475 3.56023 12 3.29629 12 3.02974C12 2.76319 11.9475 2.49925 11.8455 2.25299C11.7435 2.00673 11.594 1.78298 11.4055 1.5945C11.217 1.40602 10.9933 1.25651 10.747 1.1545C10.5007 1.0525 10.2368 1 9.97026 1C9.70371 1 9.43977 1.0525 9.19351 1.1545C8.94725 1.25651 8.7235 1.40602 8.53502 1.5945L1 9.12951V12Z"
                                          stroke="black"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                        />
                                      </svg>
                                    </div>
                                  </a>
                                </div>
                              )}

                              {address === null && (
                                <div className="text-center d-flex col-12">
                                  <button
                                    onClick={openSelectAddress}
                                    className="btn btn-primary  w-100 font-14 ff-semibold py-3  bt--cart"
                                  >
                                    Add Address
                                  </button>
                                </div>
                              )}
                            </div>

                            {/* <div className="cart-map-ico ahead">
                                <img
                                  src="https://goodhand.b-cdn.net/Assets/cart/cart-flow/documents.svg"
                                  className="img-fluid"
                                  alt=""
                                />
                              </div> */}

                            {/* <div className="flex-grow-1">
                                <p
                                  className={`mb-0 font-14 ff-semibold ${
                                    !address ? "disabled" : "text-black"
                                  }`}
                                >
                                  Documents
                                </p>
                                <p className="font-12 mb-0">
                                  Please Upload applicant documents
                                </p>
                              </div> */}
                            {address !== null && (
                              <>
                                <div className="d-flex align-items-center gap-3 p-3 flex-wrap">
                                  <div className="text-center d-flex col-12 flex-grow-1">
                                    <button
                                      className="btn btn-primary  ff-semibold w-100 font-14 py-3 bt--cart"
                                      onClick={handleData}
                                    >
                                      Upload Documents
                                    </button>
                                  </div>
                                </div>
                              </>
                            )}
                          </div>
                        </>
                      ) : (
                        <>
                          <div className="px-3 pb-3 pt-3 border-top">
                            <h2 className="font-14 ff-semibold"> Account </h2>
                            <p className="font-12 text-black">
                              To book the service, please login or signup
                            </p>
                            <button
                              className="btn btn-primary  w-100 font-14 ff-semibold py-3 me-3 bt--cart"
                              onClick={handleLogin}
                            >
                              Login
                            </button>
                          </div>
                        </>
                      )}
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </section>
      ) : (
        <div className="container d-flex justify-content-center flex-column py-5">
          <img
            loading="lazy"
            src={cartImg}
            alt="No img"
            className="d-block mx-auto my-3"
            style={{ height: "50px" }}
          />
          <p className="text-black font-16 ff-semibold text-center">
            Hey, it feels so empty here.
          </p>
          <p className="text-black font-11 ff-semibold text-center">
            Lets add some services
          </p>
          <div className="d-flex justify-content-center align-items-center">
            <Link to="/services/immigration" className="text-decoration-none">
              <button
                type="button"
                className="btn-add cart-empty position-relative my-2 px-3"
                style={{ width: "fit-content" }}
              >
                Explore services
              </button>
            </Link>
          </div>
        </div>
      )}
      {/* Main Modal select address model */}
      {showSelectAddress && <SelectAddressModel />}

      {/* Nested Modal when no address then open new model */}
      {showAddAddress && <AddAnotherAddressModel />}
      {showDetailModel && <AddDetailModel />}
      {showLoginModel && <LoginModel />}
      {showVerifyOtp && <VerifyOtp />}
      {showAddAddressFromMap && <AddressFromMap />}
      <HandleReadFullPolicyModel />
      <HandlePackageAndServiceModel />
    </>
  );
};

export default Cart;
